<template>
  <v-card
    class="elevation-0 mt-0"
    flat
    :color="$vuetify.theme.dark ? '#121212' : '#ffffff'"
  >
    <v-card-text class="pa-0">
      <v-form v-model="valid">
        <v-flex v-if="profileImage" xs12 class="d-flex justify-center pa-0">
          <div style="position: relative; height: 100px; width: 100px">
            <v-btn
              :disabled="loadingPhoto"
              icon
              elevation="2"
              @click="clickInput"
              style="
                position: absolute;
                z-index: 2;
                bottom: 5%;
                right: 5%;
                background: white;
              "
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-img
              :disabled="loadingPhoto"
              :src="model.avatar"
              height="100"
              style="
                max-width: 100px;
                max-height: 100px;
                border-radius: 50%;
                box-shadow: 0 3px 6px rgba(0, 0, 0, 16%);
              "
              v-if="model.avatar"
            >
            </v-img>
          </div>
        </v-flex>
        <v-file-input
          accept="image/png, image/jpeg, image/jpg"
          placeholder="Escolha um avatar"
          label="Avatar"
          ref="file_input"
          style="display: none"
          @change="onFilePicked"
        ></v-file-input>
        <v-layout row wrap>
          <v-flex class="pa-0 px-1" sm12 xs12>
            <v-text-field
              v-model="model.name"
              v-validate="'required|min:9|max:50'"
              :error-messages="errors.collect('nome')"
              data-vv-name="nome"
              label="Nome Completo"
              name="nome"
              placeholder=""
              prepend-inner-icon="account_circle"
              required
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" sm6 xs12>
            <v-text-field
              v-model="model.borned_at"
              v-mask="'##/##/####'"
              v-validate="'required|date_format:dd/MM/yyyy'"
              :error-messages="errors.collect('nascimento')"
              data-vv-name="nascimento"
              label="Data de Nascimento"
              prepend-inner-icon="event"
              required
              outlined
              dense
              return-masked-value
            ></v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" sm6 xs12>
            <v-text-field
              v-model="model.phone"
              v-mask="'(##) #####-####'"
              v-validate="'required|min:11'"
              :error-messages="errors.collect('telefone')"
              data-vv-name="telefone"
              label="Telefone"
              placeholder="(##) #####-####"
              prepend-inner-icon="phone"
              required
              outlined
              dense
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-subheader class="pa-0 mt-0 mb-2" style="height: unset !important"
          >Documentação</v-subheader
        >
        <v-layout row wrap>
          <v-flex class="pa-0 px-1" md3 sm12>
            <v-text-field
              v-model="model.cpf"
              v-mask="'###########'"
              v-validate="'required|min:11|max:11'"
              :error-messages="errors.collect('cpf')"
              data-vv-name="cpf"
              label="CPF"
              maxlength="11"
              name="cpf"
              placeholder="CPF válido com 11 digitos"
              required
              outlined
              dense
            >
            </v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" md3 sm12 v-if="fullDocumentation">
            <v-text-field
              v-model="model.rg"
              :error-messages="errors.collect('rg')"
              v-validate="{ required: rgRequired }"
              data-vv-name="rg"
              label="RG"
              maxlength="11"
              name="rg"
              placeholder="RG válido com até 11 digitos"
              required
              outlined
              dense
            >
            </v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" md3 sm6 v-if="fullDocumentation">
            <v-select
              v-model="model.rg_issuer_agency_id"
              :items="issuer_agencies"
              :error-messages="errors.collect('orgao-emissor')"
              v-validate="{ required: Boolean(model.rg) }"
              data-vv-name="orgao-emissor"
              item-text="acronym"
              item-value="id"
              label="Orgão Emissor"
              menu-props="auto"
              outlined
              dense
            ></v-select>
          </v-flex>
          <v-flex class="pa-0 px-1" md3 sm6 v-if="fullDocumentation">
            <v-select
              v-if="states && issuer_agencies"
              v-model="model.rg_issuer_agency_uf_id"
              :error-messages="errors.collect('uf-emissor')"
              v-validate="{ required: Boolean(model.rg) }"
              :items="states"
              data-vv-name="uf-emissor"
              item-text="state"
              item-value="id"
              label="UF Emissor"
              menu-props="auto"
              outlined
              dense
            ></v-select>
          </v-flex>
        </v-layout>
        <v-subheader class="pa-0 mt-0 mb-2" style="height: unset !important"
          >Endereço</v-subheader
        >
        <v-layout row wrap>
          <v-flex class="pa-0 px-1" sm3 xs12>
            <v-text-field
              v-model="model.zipcode"
              v-mask="'########'"
              v-validate="'required|min:8|max:9'"
              :error-messages="errors.collect('cep')"
              data-vv-name="cep"
              label="CEP"
              prepend-inner-icon="place"
              required
              outlined
              dense
              :loading="this.loadingAdress"
              @change="getAddress(model.zipcode)"
            ></v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" sm6 xs12>
            <v-text-field
              v-model="model.street"
              v-validate="'required|max:150'"
              :error-messages="errors.collect('endereço')"
              data-vv-name="endereço"
              label="Endereço"
              prepend-inner-icon="directions"
              required
              outlined
              dense
              :disabled="loadingAdress"
            ></v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" sm3 xs12>
            <v-text-field
              id="number"
              ref="streetNumber"
              v-model="model.street_number"
              v-validate="'required|max:20'"
              :error-messages="errors.collect('numero')"
              data-vv-name="numero"
              label="Número"
              prepend-inner-icon="place"
              required
              outlined
              dense
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex class="pa-0 px-1" sm2 xs12>
            <v-text-field
              v-model="model.complementary"
              v-validate="'max:50'"
              label="Complemento"
              prepend-inner-icon="add_location"
              data-vv-name="complemento"
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" sm4 xs12>
            <v-select
              v-if="states"
              v-model="model.state_id"
              v-validate="'required'"
              :error-messages="errors.collect('estado')"
              :items="states"
              data-vv-name="estado"
              item-text="state"
              item-value="id"
              label="Estado"
              menu-props="auto"
              prepend-inner-icon="map"
              required
              outlined
              dense
              :disabled="loadingAdress"
            ></v-select>
          </v-flex>
          <v-flex class="pa-0 px-1" sm3 xs12>
            <v-text-field
              v-model="model.city"
              v-validate="'required|min:2|max:50'"
              :error-messages="errors.collect('cidade')"
              data-vv-name="cidade"
              label="Cidade"
              prepend-inner-icon="location_city"
              required
              outlined
              dense
              :disabled="loadingAdress"
            ></v-text-field>
          </v-flex>
          <v-flex class="pa-0 px-1" xs12 sm3>
            <v-text-field
              label="Bairro"
              v-validate="'required'"
              data-vv-name="bairro"
              :error-messages="errors.collect('bairro')"
              v-model="model.neighborhood"
              prepend-inner-icon="place"
              required
              outlined
              dense
            ></v-text-field>
          </v-flex>
        </v-layout>
        <!--
        <v-subheader class="pa-0 mt-0 mb-2" style="height: unset !important">Autenticação</v-subheader>
        <v-layout row wrap>
          <v-flex sm3 xs12>
            <v-text-field
                v-model="model.last_password"
                v-validate="'max:50'"
                label="Senha antiga"
                prepend-icon="lock"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 xs12>
            <v-text-field
                v-model="model.password"
                v-validate="'max:50'"
                label="Nova senha"
                prepend-icon="lock"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 xs12>
            <v-text-field
                v-model="model.password_confirmation"
                v-validate="'max:50'"
                label="Confirmar nova senha"
                prepend-icon="lock"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 xs12 class="d-flex align-center justify-center">
            <v-btn :loading="loadingPassword" :disabled="loadingPassword" text @click="sendResetEmail">Alterar senha</v-btn>
          </v-flex>
        </v-layout>
        -->
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="px-5"
        rounded
        depressed
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="submit"
        v-show="showBtnOnCheckout"
        >{{ this.submitLabel }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import UsersService from "@/services/users.service";
import { mask } from "vue-the-mask";
import AddressService from "@/services/address.service";
import { sendResetEmailAuth } from "@/services/auth.service";
import IssuerAgencyService from "../../../services/issuerAgency.service";
import StatesService from "../../../services/states.service";

export default {
  directives: { mask },
  $_veeValidate: {
    validator: "new",
  },
  props: {
    model: {
      required: false,
    },
    submitLabel: {
      default: "Atualizar",
    },
    fullDocumentation: {
      default: true,
    },
    profileImage: {
      default: true,
    },
    rgRequired: {
      default: false,
    },
    loading: {
      default: false,
    },
    showBtnOnCheckout: {
      default: true,
      required: false,
    },
  },
  data: () => ({
    states: null,
    issuer_agencies: null,
    loadingPhoto: false,
    loadingAdress: false,
    valid: true,
    loadingPassword: false,
  }),
  mounted() {
    StatesService.getListPublic().then((response) => {
      this.states = response.data;
    });
    IssuerAgencyService.getListPublic().then((response) => {
      this.issuer_agencies = response.data;
    });
  },
  methods: {
    async sendResetEmail() {
      this.loadingPassword = true;
      try {
        const response = await sendResetEmailAuth(this.model);
        // const { status } = response.data
        // console.log(response)
        window.getApp.sendSnackMessage(
          "Enviamos um link para definição de outra senha. Verifique seu email ;)",
        );
      } catch (error) {
        console.error(error);
        window.getApp.sendSnackMessage(
          "Email não foi encontrado na base de dados",
          "error",
        );
      } finally {
        this.loadingPassword = false;
      }
    },
    submit() {
      this.$emit("update:loading", true);
      this.formHasErrors().then((hasError) => {
        if (!hasError) this.$emit("submit", this.model);
      });
      this.$emit("update:loading", false);
    },
    clickInput() {
      this.$refs.file_input.$refs.input.click();
    },
    getAddress(zipcode) {
      console.log("cep: ", zipcode);
      if (zipcode.length < 8) return;
      this.loadingAdress = true;
      const _this = this;
      AddressService.getAddress(zipcode)
        .then((res) => {
          if (res.success) {
            _this.model.street = res.data.street;
            _this.model.city = res.data.city;
            _this.model.state_id = res.data.state.id;
            this.$refs.streetNumber.focus();
          }
          this.loadingAdress = false;
        })
        .catch((error) => {
          this.loadingAdress = false;
          console.log(error.message);
        });
    },
    async onFilePicked(file) {
      // if file bigger than 200kb block it
      if (file.size > 200000) {
        window.getApp.sendSnackMessage("Arquivo muito grande, máximo 200kb");
        return;
      }
      this.loadingPhoto = true;
      try {
        const { data } = await UsersService.updateAvatar(file);
        console.log("avatar atualizado", data.avatar);
        this.$emit("new_avatar", data.avatar);
      } catch (error) {
        console.log(error);
      }
      this.loadingPhoto = false;
    },
  },
};
</script>
